module.exports = __webpack_public_path__ + "img/img_maeda.8d9b6be9.png";